import { type ProblemDetails } from '../../types/error.types';

export class ApiError extends Error {

    public readonly status?: number;
    public readonly title?: string;
    public readonly type?: string;
    public readonly traceId?: string;

    constructor(problem: ProblemDetails) {

        super(problem.detail ?? "API error");

        this.name = "ApiError";

        this.status = problem.status;
        this.title = problem.title;
        this.type = problem.type;
        this.traceId = problem.traceId;
    }

    static fromProblemDetails(problem: ProblemDetails): ApiError {
        return new ApiError(problem);
    }
}